import React from "react"
import './music.css'

const img_list = [
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137er9j4sn1yZ.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137hrNgOMiDqK.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137AoX2Ry4ip0.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137zATtAUgqvO.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137jpFS1V6Op6.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137t5vilsrZTk.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/11374elzCGbnya.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137Gsq9ZrEUjI.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137tywubUoNy7.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137SMBOwmMW0T.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137squNEpcwO1.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1137HABo57P6lK.png'
]


export default function Music () {
    return (
        <>
            <div className='mus_box'>
                <div className='one'>
                    {img_list.slice(0, 3).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
                <div className='two'>
                    {img_list.slice(3, 6).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
                <div className='three'>
                    {img_list.slice(6, 8).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='four'>
                    {img_list.slice(8 , 10).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='five'>
                    {img_list.slice(10 , 12).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    )
}